module.exports = __webpack_public_path__ + "img/universal-access-solid.397eb948.svg";